export const constants = {
  APP_PREFIX: 'BT5',
  SPACE: ' ',
  EMPTY: '',
  PERIOD: '.',
  COMMA: ',',
  EMDASH: '—',
  DASH: '-',
  PERCENT: '%',
};
